module.exports = __webpack_public_path__ + "static/WTP2-1ea47fa2adcc1c56e67a5e8c7c5c0f27.jpg";